<template>
    <!-- 전체 콘텐츠 영역 -->
    <div class="main-contents notice">
        <div class="mem_container">
            <div class="mem_info_contents flex flex-row">
                <div class="mem_contents_header" style="width: 210px">
                    <div class="title-txt">알림<br/>
                        <p><span>{{totalCnt || 0}}</span>개의 알림이 있습니다.</p>
                    </div>
                </div>
                <scroll class="contents-body" :winScroll="true" @scrollBottom="scrollBottom">
                    <div class="notice_tit">전체알림</div>
                                
                    <div v-for="item in list" :key="item.notiSeq" class="nt_list">
                        <div class="date" v-if="item.dateRn != undefined">
                            <div class="new" v-if="item.notiNewYn == 'Y'"></div>
                            {{item.regDate | date('yyyy년 MM월 dd일 KS요일')}}           
                        </div>
                        <div class="speech-bubble" :title="item.notiCont" @click="clickNoti(item)" :class="{'btn_cursor':item.notiViewLinkUrl}">

                            <div class="point_gd" v-if="item.notiViewDisplayTypeCd == '02'">
                                <div class="group-txt">
                                    프로젝트
                                </div>
                                <nbsp tagNm="div" class="greet" :value="item.notiCont"/>
                            </div>
                            
                            <div class="point_gd" v-else-if="item.notiViewDisplayTypeCd == '03'">
                                <div class="group-txt">
                                    포인트
                                </div>
                                <div class="greet">
                                    <template v-for="(str1, idx1) in item.notiCont.split('\n')">
                                        <template v-for="(str2, idx2) in str1.split('(P)')">
                                            <img src="/images/admin/point_s.png" alt="포인트" :key="idx1 + '_' + idx2" v-if="idx2 != 0"/>{{str2}}
                                        </template>
                                        <br :key="idx1"/>
                                    </template>
                                </div>
                            </div>
                            
                            <div class="point_gd" v-if="item.notiViewLinkUrl == '/PRF101M01' && lastFixResume != item.notiSeq && item.notiResumeYn == 1">
                                <div class="group-txt">
                                    프로필
                                </div>
                                <nbsp tagNm="div" class="greet" :value="'이력서 수정이 완료되었습니다.'"/>
                            </div>

                            <div class="point_gd" v-else-if="item.notiViewDisplayTypeCd == '01'">
                                <div class="group-txt">
                                    프로필
                                </div>
                                <nbsp tagNm="div" class="greet" :value="item.notiCont"/>
                                <!-- <p v-if="item.notiViewLinkUrl == '/PRF101M01' && lastFixResume != item.notiSeq">수정완료</p> -->
                            </div>

                            <!-- <div v-else-if="item.notiViewLinkUrl == '/PRF101M01' && lastFixResume != item.notiSeq">
                                <nbsp tagNm="div" class="nt" :value="item.notiCont"/><p>수정완료</p>
                            </div>
                            <nbsp tagNm="div" class="nt" v-else :value="item.notiCont"/> -->
                            <!-- <div class="regdate">등록일자 2025.00.00 24:00:00</div> -->
                            <div class="regdate">등록일자 {{item.regDate | date('yyyy.MM.dd HH:mm:ss')}}</div>
                        </div>
                    </div>
                </scroll>
            </div>
        </div>
    </div>
</template>

<script>
import scroll from "@/components/Scroll.vue";

export default {
    components: { scroll },
    data() {
        return {
            totalCnt: 0,
            newCnt: 0,
            list: [],
            nextKey: '',
            lastFixResume:'',
            gender: this.$store.state.userInfo.gender,
            mberDivCd : this.$store.state.userInfo.mberDivCd.substr(0,1),
        };
    },
    mounted(){
        this.search();
    },
    methods: {
        search(){
            if(this.nextKey === undefined) return;
			this.$.httpPost('/api/mem/myp/getNoti', {nextKey : this.nextKey})
				.then(res => {
					//console.log('RESULT :', res);
                    if(res.data && Array.isArray(res.data.list)){
                        this.$store.commit("notiNewCnt", 0);
                        this.totalCnt= res.data.notiCnt;
                        this.newCnt  = res.data.notiNewCnt;
                        this.list    = this.list.concat(res.data.list);
                        this.nextKey = res.data.nextKey;
                        if(this.$store.state.userInfo.mberDivCd == 11 && res.data.lastFix[0] != null) {
                            if(Object.values(res.data.lastFix[0]).length != 1) {
                                this.lastFixResume = res.data.lastFix[0].notiSeq;
                            }
                        }
                        // if(res.data.lastFix[0]) {
                        //     this.lastFixResume = res.data.lastFix[0].notiSeq;
                        // }
                    }
				})
				.catch( this.$.httpErrorCommon );
        },
        clickNoti(item){
            if(item.notiViewLinkUrl){
                if(item.notiViewLinkUrl.indexOf('http') == 0){
                    location.href = item.notiViewLinkUrl;
                } else {
                    this.$router.push(item.notiViewLinkUrl);
                    // if(item.notiViewLinkUrl == '/PRF101M01' && this.lastFixResume != item.notiSeq && this.$store.state.userInfo.mberDivCd == 11) {
                    //     // this.$router.push(item.notiViewLinkUrl);
                    // }
                    //  else {
                    //     this.$router.push(item.notiViewLinkUrl);
                    // }
                    
                }
            }
        },
        scrollBottom(){
            this.search();
        }
    },
};
</script>